import { useState } from 'react';
import { tickerFeeds } from '@/mocks/homeData';

const navItems = [
  { href: '#flash', label: '快讯流' },
  { href: '#archive', label: '最新入档' },
  { href: '#category', label: '档案分类' },
  { href: '#hot', label: '热度榜' },
  { href: '#digest', label: '整全盘点' },
  { href: '#guide', label: '使用说明' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const feeds = [...tickerFeeds, ...tickerFeeds];

  return (
    <header className="sticky top-0 z-50 w-full">
      {/* 快讯跑马灯 */}
      <div className="w-full bg-primary-600 text-background-50 overflow-hidden">
        <div className="relative flex items-center gap-0">
          <div className="relative z-10 flex shrink-0 items-center gap-1.5 bg-primary-700 px-3 py-1.5 text-xs font-semibold tracking-wide whitespace-nowrap">
            <i className="ri-broadcast-line text-sm" aria-hidden="true"></i>
            本台快讯
          </div>
          <div className="relative flex-1 overflow-hidden">
            <div className="ticker-track">
              {feeds.map((f, i) => (
                <span key={i} className="mx-6 inline-flex items-center gap-2 text-xs text-background-50/95">
                  <span className="inline-block h-1 w-1 rounded-full bg-accent-300"></span>
                  {f}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 主导航 */}
      <div className="w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
          <div className="flex items-center gap-2 py-3">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
                  扒哥黑料
                </span>
                <span className="mt-1 text-[10px] font-medium tracking-[0.2em] text-foreground-500">
                  档案 · 汇总 · 备查
                </span>
              </span>
            </a>
          </div>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navItems.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#download"
              className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-3.5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              <i className="ri-download-2-line text-base" aria-hidden="true"></i>
              下载App
            </a>
            <button
              type="button"
              aria-label="展开菜单"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700 md:hidden"
              onClick={() => setOpen((v) => !v)}
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
            </button>
          </div>
        </div>

        {open && (
          <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden" aria-label="移动导航">
            <div className="grid grid-cols-2 gap-2">
              {navItems.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="whitespace-nowrap rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-800"
                >
                  {n.label}
                </a>
              ))}
              <a
                href="#download"
                onClick={() => setOpen(false)}
                className="col-span-2 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-3 py-2.5 text-sm font-semibold text-background-50"
              >
                <i className="ri-download-2-line text-base" aria-hidden="true"></i>
                下载App
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}